import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Avatar, HsId, PageHeader, Row, Section, Spinner, StatusBadge } from "@/components/kit";
import { fdate } from "@/lib/format";

export default function PersonProfile() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/persons/${id}`).then((r) => setD(r.data));
  }, [id]);
  if (!d) return <Spinner />;
  const p = d.person;
  const roleLine = d.roles.includes("karta") ? "Karta" : d.karta ? `Coparcener under ${d.karta.full_name}${d.relation ? ` · ${d.relation}` : ""}` : "Coparcener";
  return (
    <div className="pb-6">
      <PageHeader title="Profile" />
      <div className="hd-card text-center py-6" data-testid="person-profile-card">
        <div className="flex justify-center"><Avatar name={p.full_name} id={p.id} size={64} /></div>
        <div className="text-xl font-bold mt-3" data-testid="person-name">{p.full_name}</div>
        <div className="mt-2 flex justify-center"><HsId value={p.hs_id} big testid="person-hs-id" /></div>
        <div className="text-sm text-[#718096] mt-2" data-testid="person-role-line">{roleLine}</div>
        <div className="mt-2 flex justify-center"><StatusBadge status={p.status} /></div>
      </div>
      <div className="hd-card mt-3">
        <Row label="Role(s)">{d.roles.map((r) => r[0].toUpperCase() + r.slice(1)).join(", ")}</Row>
        {d.karta && <Row label="Karta / Family"><Link className="text-[#C8553D] font-semibold" to={`/person/${d.karta.id}`}>{d.karta.full_name} ({d.karta.hs_id})</Link></Row>}
        <Row label="Mobile">{p.mobile || "—"}</Row>
        <Row label="Email">{p.email || "—"}</Row>
        <Row label="Login access">{d.has_login ? "Yes" : "Not yet"}</Row>
        <Row label="Member since">{fdate(p.created_at.slice(0, 10))}</Row>
      </div>
      <Section title="Groups">
        <div className="hd-card py-1">{d.groups.map((g) => <Row key={g.id} label={g.name}>{g.role === "karta" ? "Karta" : `Coparcener · ${g.side_name} side`}</Row>)}</div>
      </Section>
      {d.demat_accounts.length > 0 && (
        <Section title="Demat accounts">
          <div className="hd-card py-1">{d.demat_accounts.map((x) => <Row key={x.id} label={x.account_name}>{x.broker}{x.status !== "active" ? " · inactive" : ""}</Row>)}</div>
        </Section>
      )}
      {d.coparceners.length > 0 && (
        <Section title="Coparceners">
          <div className="hd-card py-1">
            {d.coparceners.map((c) => (
              <Link key={c.id} to={`/person/${c.id}`} className="flex items-center gap-3 py-2.5 border-b border-[#E2D9CF]/50 last:border-0">
                <Avatar name={c.full_name} id={c.id} size={34} />
                <div className="flex-1 text-sm font-semibold">{c.full_name}<div className="text-[11px] text-[#718096] font-normal">{c.relation}</div></div>
                <HsId value={c.hs_id} />
              </Link>
            ))}
          </div>
        </Section>
      )}
    </div>
  );
}
